import axios from "axios";
import config from "../config";

const timeoutMs = (config.requestTimeoutDuration ?? 30) * 1000;
axios.defaults.timeout = timeoutMs;

axios.interceptors.response.use(null, (error) => {
  const status = error.response?.status;
  const expectedError = status != null && status >= 400 && status < 600;
  if (!expectedError && process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.warn("Request error", error.message, error.response?.data);
  }
  return Promise.reject(error);
});

function setHeaders(jwt) {
  axios.defaults.headers.common["Authorization"] = "Bearer " + jwt;
  axios.defaults.headers.common["Content-Type"] = "application/json";
}
function setAuthHeader() {
  const token = localStorage.getItem(config.keys.token);
  axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  axios.defaults.headers.common["Content-Type"] = "application/json";
}

function resetHeaders() {
  axios.defaults.headers.common["Authorization"] = "";
  axios.defaults.headers.common["Content-Type"] = "";
}
function removeHeaders() {
  delete axios.defaults.headers.common["Authorization"];
  delete axios.defaults.headers.common["Content-Type"];
  delete axios.defaults.headers["Content-Type"];
  delete axios.defaults.headers.post["Content-Type"];
}

const axiosObj = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  setHeaders,
  setAuthHeader,
  resetHeaders,
  removeHeaders,
};

export default axiosObj;
